module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"end":"End","pause":"Break","start":"Start","title":"Trip history"},"de":{"end":"Ende","pause":"Pause","start":"Start","title":"Zeiterfassung"},"fr":{"end":"Fin","pause":"Pause","start":"Début","title":"Parcours"},"it":{"end":"Fine","pause":"Rottura","start":"Inizio","title":"Percorso di viaggio"}}')
  delete Component.options._Ctor
}
